<template><article><h1>进度条</h1>
<h2 id="process"><a class="header-anchor" href="#process" aria-hidden="true">#</a> process</h2>
<h3 id="当值的类型为-boolean"><a class="header-anchor" href="#当值的类型为-boolean" aria-hidden="true">#</a> 当值的类型为 <code v-pre>Boolean</code></h3>
<p><example :value="example1"></example></p>
<h3 id="当值的类型为-function"><a class="header-anchor" href="#当值的类型为-function" aria-hidden="true">#</a> 当值的类型为 <code v-pre>Function</code></h3>
<p>当<code v-pre>process</code>是一个函数时，参数是一个数组（从小到大的滑块位置），函数必须返回一个数组，里面可以包含任意个进度条数组。</p>
<p>每个进度条数组代表一段进度条，进度数组必须包含起点（索引0）和终点（索引1），和可选的进度条样式（索引2）。</p>
<p>位置是以百分比表示，<code v-pre>0</code>代表起点，<code v-pre>100</code>代表终点。</p>
<p>每当滑块的值发生变化时，该函数就会被调用。</p>
<p><example :value="example2"></example></p>
</article></template>

<script>
  import examples from '@/examples/process.ts'
  export default {
    data () {
      return {
        ...examples
      }
    }
  }
</script>